import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 56.7v398.5c0 13.7-11.1 24.7-24.7 24.7h-114.2v-173.4h58.2l8.7-67.6h-67v-43.2c0-19.6 5.4-32.9 33.5-32.9h35.8v-60.5c-6.2-0.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9h-58.4v67.6h58.4v173.5h-214.4c-13.6 0-24.7-11.1-24.7-24.7v-398.6c0-13.6 11.1-24.7 24.7-24.7h398.5c13.7 0 24.8 11.1 24.8 24.7z'
      }
    ]
  }
})
